import { faLink, faUsers } from '@fortawesome/pro-solid-svg-icons'
import { SynchronousCourseTypes } from 'enum'
import { Types } from '../../CourseCards/components/atoms/Tags/types'

export const synchronousTypes: Types = {
  [SynchronousCourseTypes.faceToFace]: {
    title: 'faceToFace',
    icon: faUsers,
  },
  [SynchronousCourseTypes.external]: {
    title: 'externalCourse',
    icon: faLink,
  },
}
